
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.367 4.854a.5.5 0 000-.708L8.185.964a.5.5 0 00-.707.708L10.306 4.5 7.478 7.328a.5.5 0 10.707.708l3.182-3.182zM.983 5h10.03V4H.983v1z","fill":"#D4DDEA"}})])
          )
        }
      }
    